export default "__VITE_ASSET__D2Ld5YCj__"